<template>
    <v-form v-model="is_valid"
            :disabled="loading">
        <v-container class="base container-fluid">
            <h1>Autenticação com aplicativo</h1>
            <v-row v-if="loading">
                <v-col class="justify-center align-center pa-8">
                    <v-progress-circular :size="35"
                                        color="primary"
                                        indeterminate />
                </v-col>
            </v-row>
            <v-row v-if="is_2fa_enabled">
                <v-col>
                    <div v-if="recovery_codes === 0"
                            class="alert-panel">
                        <strong>Você não possui códigos de recuperação.</strong> Você deve
                        <router-link to="./recovery-2fa">gerar novos códigos de recuperação</router-link>
                        para o caso de perder seu dispositivo cadastrado
                        ou o aplicativo de autenticação.
                    </div>
                    <div v-if="recovery_codes === 1"
                            class="alert-panel">
                        <strong>Você possui somente 1 código de recuperação reservado.</strong>
                        Você deve
                        <router-link to="./recovery-2fa">gerar novos códigos de recuperação</router-link>
                        para o caso de perder seu dispositivo cadastrado
                        ou o aplicativo de autenticação.
                    </div>
                    <div v-if="recovery_codes && recovery_codes <= 3"
                            class="warning-panel">
                        <strong>Você possui {{ recovery_codes }} códigos de recuperação reservados.</strong>
                        Você deveria
                        <router-link to="./recovery-2fa">gerar novos códigos de recuperação</router-link>
                        para o caso de perder seu dispositivo cadastrado
                        ou o aplicativo de autenticação.
                    </div>
                    <div v-if="!!recovery_codes" class="info-panel">
                        <strong>Você possui {{ recovery_codes }} códigos de recuperação reservados.</strong>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="is_2fa_enabled">
                <v-col>
                    <div>
                        <ul>
                            <li>
                                <router-link to="./disable-2fa">Desabilitar autenticação via aplicativo.</router-link>
                            </li>
                        </ul>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="is_2fa_enabled && is_remembered">
                <v-col>
                    <div>
                        <strong>Você ativou o recurso manter-se conectado.</strong>
                        Clique no botão <em>Desconectar</em> para desativar o recurso.
                    </div>
                    <div class="ctrls-panel">
                        <v-btn @click="forgetClient">Desconectar</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <div v-if="has_auth">
                        <ul>
                            <li>
                                <router-link to="./enable-2fa">
                                    Configurar a autenticação via aplicativo.
                                </router-link>
                            </li>
                            <li v-if="is_2fa_enabled">
                                <router-link to="./reset-2fa">
                                    Reinicializar a autenticação
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <router-link to="./enable-2fa">Habilitar a autenticação via aplicativo.</router-link>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn @click="goBack"
                           color="primary"
                           :loading="loading"
                           :disabled="!is_valid"
                           large
                           rounded>
                        Voltar para o aplicativo
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
</style>

<script lang="js">
import ApiService from '@/services/ApiService';

export default              {
    data                    () {
        return              {
            api             : undefined,
            is_valid        : false,
            loading         : false,

            has_auth        : false,
            is_2fa_enabled  : false,
            is_remembered   : false,
            recovery_codes  : 0
        }
    },
    methods                 : {
        async loadStatus    () {
            this.loading = true;
            try {
                const resp = await this.api.mfaGetStatus();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada ao carrregar dados.');
                    return;
                }
                const body           = resp.content || {
                    has_authenticator       : false,
                    is_2fa_enabled          : false,
                    is_machine_remembered   : false,
                    recovery_codes_left     : 0
                };
                this.has_auth        = body.has_authenticator;
                this.is_2fa_enabled  = body.is_2fa_enabled;
                this.is_remembered   = body.is_machine_remembered;
                this.recovery_codes  = body.recovery_codes_left;
            } finally {
                this.loading = false;
            }
        },
        async forgetClient  () {
            try {
                this.loading = true;
                const resp = await this.api.mfaForgetClient();
                if (!resp.success) {
                    this.$toast.error(
                        resp.message ||
                        'Falha não identificada ao realizar a operação.');
                    return;
                }
                this.is_remembered = false;
                this.$toast.info(
                    'Sua conexão será encerrada quando fechar a aba ou o navegador. ' +
                    'Você precisará se conectar novamente quando precisar entrar no sistema.');
            } finally {
                this.loading = false;
            }
        },
        getUser             () {
            return this.$store.getters.$userLogged;
        },
        goBack              () {
            const user      = this.getUser();
            if (user.userProfile == 0) {
                this.$router.push("/visao-geral");
            } else {
                this.$router.push("/gestao-usuario");
            }
        }
    },
    mounted                 () {
        this.api    = new ApiService();
        return this.loadStatus();
    }
}
</script>